import { render, staticRenderFns } from "./PerformancePersonConfigEdit.vue?vue&type=template&id=3e25f51a&scoped=true&"
import script from "./PerformancePersonConfigEdit.vue?vue&type=script&lang=js&"
export * from "./PerformancePersonConfigEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e25f51a",
  null
  
)

export default component.exports